import { render, staticRenderFns } from "./EarthquakeStatisticCard.vue?vue&type=template&id=48ee35a2&"
import script from "./EarthquakeStatisticCard.vue?vue&type=script&lang=js&"
export * from "./EarthquakeStatisticCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports